export const MIN_WIDTH = 500;
